import * as types from '../mutation-types';
import {unionState, toDateTimeString} from '../helpers';

const state = () => ({
	categories: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/categories').then(response => {
			commit(types.STORE_CATEGORYIES, response.data);
		});
	},

	create({commit}, {name, description, tag, is_featured, has_dimensions, can_upload_attachments, 
		attributes, parent_id, image}) {
		const formData = new FormData();
		formData.append('name', name);
		formData.append('description', description);
		formData.append('tag', tag);
		formData.append('is_featured', is_featured ? 1 : 0);
		formData.append('has_dimensions', has_dimensions ? 1 : 0);
		formData.append('can_upload_attachments', can_upload_attachments ? 1 : 0);
		formData.append('parent_id', parent_id);
		formData.append('image', image);

		for (let attribute of attributes)
			formData.append('attributes[]', attribute);

		return axios.post('/api/categories', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_CATEGORY, response.data);

			return response.data;
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/categories/${id}`).then(response => {
			commit(types.STORE_CATEGORY, response.data);

			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/categories/${id}`).then(() => {
			commit(types.DELETE_CATEGORY, id);
		});
	},

	// restore({commit}, {id}) {
	// 	return axios.patch(`/api/categories/${id}`).then(() => {
	// 		commit(types.RESTORE_CATEGORY, id);
	// 	});
	// },

	update({commit}, {id, name, description, tag, is_featured, has_dimensions, can_upload_attachments, 
		attributes, parent_id, image}) {
		const formData = new FormData();
		formData.append('name', name);
		formData.append('description', description);
		formData.append('tag', tag);
		formData.append('is_featured', is_featured ? 1 : 0);
		formData.append('has_dimensions', has_dimensions ? 1 : 0);
		formData.append('can_upload_attachments', can_upload_attachments ? 1 : 0);
		formData.append('parent_id', parent_id);

		if (image)
			formData.append('image', image);

		for (let attribute of attributes)
			formData.append('attributes[]', attribute);

		formData.append('_method', 'PUT');

		return axios.post(`/api/categories/${id}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_CATEGORY, response.data);

			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_CATEGORYIES](state, categories) {
		state.categories = unionState(state.categories, categories);
	},

	[types.STORE_CATEGORY](state, category) {
		state.categories = unionState(state.categories, [category]);
	},

	[types.DELETE_CATEGORY](state, id) {
		state.categories = state.categories.find(p => p.id !== id);
	},

	// [types.RESTORE_CATEGORY](state, id) {
	// 	const category = state.categories.find(p => p.id === id);
	// 	category.deleted_at = null;
	// },
};

const getters = {
	getById: state => id => state.categories.find(c => c.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};